var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadarProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 21.0547C1.83301 17.0046 5.11625 13.7214 9.16634 13.7214C13.2164 13.7214 16.4997 17.0046 16.4997 21.0547H14.6663C14.6663 18.0171 12.2039 15.5547 9.16634 15.5547C6.12877 15.5547 3.66634 18.0171 3.66634 21.0547H1.83301ZM9.16634 12.8047C6.12759 12.8047 3.66634 10.3434 3.66634 7.30469C3.66634 4.26594 6.12759 1.80469 9.16634 1.80469C12.2051 1.80469 14.6663 4.26594 14.6663 7.30469C14.6663 10.3434 12.2051 12.8047 9.16634 12.8047ZM9.16634 10.9714C11.1922 10.9714 12.833 9.33052 12.833 7.30469C12.833 5.27885 11.1922 3.63802 9.16634 3.63802C7.14051 3.63802 5.49967 5.27885 5.49967 7.30469C5.49967 9.33052 7.14051 10.9714 9.16634 10.9714ZM16.7597 14.3656C19.3087 15.5144 21.083 18.0774 21.083 21.0547H19.2497C19.2497 18.8217 17.9189 16.8995 16.0072 16.0379L16.7597 14.3656ZM16.1295 4.0168C17.9612 4.77197 19.2497 6.57466 19.2497 8.67969C19.2497 11.3107 17.2369 13.4695 14.6663 13.7008V11.8556C16.2217 11.6334 17.4163 10.2967 17.4163 8.67969C17.4163 7.41409 16.6845 6.32022 15.6206 5.79801L16.1295 4.0168Z",
    fill: "#251169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarProfile);
export default __webpack_public_path__ + "static/media/radar_profile.38c4dd5624ef7b762886e35b41765c56.svg";
export { ForwardRef as ReactComponent };